import axios from 'axios';

import {
    getStoredRoleData,
    getStoredTokenData
} from '../store/auth-context';
import { API_CONSTANTS } from './apiConstants';

const API_URL = API_CONSTANTS.API_URL;

export const setNewUserInfo = async (newUserInfo) => {
    const token = getStoredTokenData().token;
    const role = getStoredRoleData().role.toLocaleLowerCase();
    const url = `${API_URL}/api/${role}/update`;
    let options = {
        headers: {
            token: `${token}`
        }
    };
    return axios.patch(url, newUserInfo, options);
};
